import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class EndUserCommunicationTrackerService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('EndUserCommunicationTracker');
	}

	loadAllForShipment(id: System.Guid): Observable<TooBig4Car.Logic.EndUserCommunicationTracker[]> {
		return this.myBaseService.loadAll(this.url + '/Shipment/' + (id || ''));
	}
	loadContent(id: System.Guid): Observable<any> {
		return this.myBaseService.getPlain(this.url + '/Content/' + (id || ''), 'Could not load content');
	}
	loadAllForPerson(id: System.Guid): Observable<TooBig4Car.Logic.EndUserCommunicationTracker[]> {
		return this.myBaseService.loadAll(this.url + '/Person/' + (id || ''));
	}
	loadAllForPickupDelivery(id: System.Guid): Observable<TooBig4Car.Logic.IHistoryDisplay[]> {
		return this.myBaseService.loadAll(this.url + '/PickupDelivery/' + (id || ''));
	}
	resend(id: System.Guid, sms: boolean): Observable<string> {
		return this.myBaseService.post(null, this.url + '/Reservation/' + (id || '') + '?sms=' + (sms || false).toString(), true);
	}
}

